export default __webpack_public_path__ + "static/media/building.9e0ab708.svg";